import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { onboardingQKeys } from "./queryKeys";


export const useGetQueue = (status?: string, verificationStatus?: string) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: [...onboardingQKeys.queue(), status, verificationStatus],
    queryFn: () => {
      let url = `onboarding/admin/queue`;
      const params = new URLSearchParams();
      if (status && status !== "all") params.set("status", status);
      if (verificationStatus && verificationStatus !== "all") {
        params.set("verification_status", verificationStatus);
      }
      if (params.size) url += `?${params.toString()}`;
      return api.get(url);
    },
    select: (res: any) => res.data,
    onError: (res: any) => {
      console.error("[From Get Queue]", res);
      handleErrors(res, "query");
    },
  });
};
